module.exports = __webpack_public_path__ + "img/sar-symbol.8ffea048.svg";